import { URL_PAGE_ABOUT, URL_PAGE_CATALOG, URL_PAGE_DELIVERY_INFO, URL_PAGE_LOYALTY } from './routes'

export const NAVIGATION = [
  {
    title: 'about_company',
    links: [
      // {
      //   title: "to_buyer",
      //   url: "/to-buyer",
      //   showHeader: false,
      // },
      // {
      //   title: "jobs",
      //   url: "/jobs",
      //   showHeader: false,
      // },
      {
        title: 'about',
        url: URL_PAGE_ABOUT,
        showHeader: true,
      },
      // {
      //   title: "blog",
      //   url: "/blog",
      //   showHeader: true,
      // },
    ],
  },
  {
    title: 'to_buyer',
    links: [
      {
        title: 'loyalty',
        url: URL_PAGE_LOYALTY,
        showHeader: true,
      },
      {
        title: 'delivery',
        url: URL_PAGE_DELIVERY_INFO,
        showHeader: true,
      },
      {
        title: 'catalog',
        url: URL_PAGE_CATALOG,
        showHeader: false,
      },
    ],
  },
]
